import { CustomHandler } from "@crescentParts/Store/CustomHandlerCreator";
import WarehouseDataState from "@crescentParts/Store/Data/WarehouseData/WarehouseDataState";
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

type Props = {
    parameter: WarehouseDataState;
};

type HandlerType = CustomHandler<WarehouseDataState, Props>

export const selectWarehouseForInventory: HandlerType = (props) => {
    props.dispatch({
        type: 'Custom/WarehouseData/setSelectedWarehouseForInventory',
        param:props.parameter.selectedWarehouseForInventory
    })
}

export const chain = [selectWarehouseForInventory];

const selectWarehouseForInventoryHandler = createHandlerChainRunner(chain, "SelectWarehouseForInventoryHandler");
export default selectWarehouseForInventoryHandler;